import { useCallback, useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { editStateAtom, editModelAtom } from '../payor_edit_atoms';
import { editStateVM, modelVM } from '../payor_edit_view_models';
import { getDetail } from '../../data/payorRepo';
import { usePayorEditStore } from '../pagehooks/usePayorEditStore';

const usePayorEditFormInit = (): void => {
    const { state: pageState } = usePayorEditStore();
    const setState = useSetImmerAtom(editStateAtom);
    const setModel = useSetImmerAtom(editModelAtom);

    const getModel = useCallback(
        async (id: string): Promise<void> => {
            try {
                const r = await getDetail(id);
                setModel(() => modelVM(r));
                setState(draft => {
                    draft.init = false;
                });
            } catch (err: any) {
                // handled upstream, need a catch when using a try/finally
            } finally {
                setState(draft => {
                    draft.waiting = false;
                });
            }
        },
        [setModel, setState],
    );

    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                if (pageState.mode == 'CREATE') {
                    setModel(() => modelVM());
                    draft.init = false;
                    draft.waiting = false;
                } else if (!draft.waiting) {
                    // get payor async
                    draft.waiting = true;
                    getModel(pageState.id);
                }
            }
            return draft;
        });

        // destroy atoms
        return (): void => {
            setState(() => editStateVM());
            setModel(() => modelVM());
        };
    }, [pageState.mode, setState, setModel, pageState.id, getModel]);
};

export default usePayorEditFormInit;
